// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3T_Id","filesListContainer":"PosDisputesFiles_filesListContainer__sEEmu","filesButton":"PosDisputesFiles_filesButton__2Aqmq"};